import { Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { AuiIconComponent } from '@ral/ui:aui/icons';
import { StoryContainerComponent } from '@storyteller/container';
import { StoryFooterComponent } from '@storyteller/footer';
import { StoryNavigationComponent } from '@storyteller/navigation';
import { StoryTitleComponent } from '@storyteller/title';
import { LogoComponent } from '../components';
import { NewsletterComponent } from '../components/newsletter.component';
import { ROUTES_NAMES } from '../utils/routes';
import { AuiItemComponent } from '@ral/ui:aui/item';

@Component({
    selector: 'app-layout',

    template: `
        <story-navigation>
            <a [routerLink]="['/']" navigationLogo aria-label="Back to home">
                <app-logo
                    [color]="'fill-surface-background'"
                    class="block aspect-[1602/195] h-[16px] w-[132px] md:w-[150px] lg:h-[22px]"
                />
            </a>
            <li>
                <a class="nav-link" [routerLink]="['/']" fragment="solutions">
                    <span class="story-font-headline1 lg:aui-font-regular-16 block py-2 lg:py-0"> Naše řešení </span>
                </a>
            </li>
            <li>
                <a class="nav-link" [routerLink]="['/']" fragment="about">
                    <span class="story-font-headline1 lg:aui-font-regular-16 block py-2 lg:py-0"> O nás </span>
                </a>
            </li>
            <li>
                <a class="nav-link" [routerLink]="['/']" fragment="contact">
                    <span class="story-font-headline1 lg:aui-font-regular-16 block py-2 lg:py-0"> Kontakt </span>
                </a>
            </li>
        </story-navigation>
        <main>
            <router-outlet />
        </main>
        <story-footer>
            <story-container
                [space]="'pb-4 pt-0 w500:pt-6 md:pt-12'"
                [skipTopPadding]="true"
                [skipSmallScreenTopPadding]="true"
            >
                @if (!isSuccessfullySubscribedPage()) {
                    <app-newsletter />
                }
                <div class="block py-12 sm:pt-4 md:pt-8 lg:pb-14 lg:pt-6">
                    <div class="block h-[1px] w-full bg-surface-background-darken"></div>
                </div>
                <footer>
                    <div class="flex flex-col justify-between gap-8 md:flex-row">
                        <div class="flex flex-col sm:flex-row gap-8 sm:gap-20">
                            <div class="flex flex-col gap-2">
                                <story-title [headingLevel]="4" className="story-font-headline3">
                                    MK SET s.r.o.
                                </story-title>
                                <p class="story-gray-text">IČO: 26079941</p>
                                <p class="story-gray-text max-w-[240px]">
                                    Cílkova 667/3, Kamýk,<br />
                                    142 00 Praha
                                </p>
                            </div>
                            <div class="flex flex-col gap-2">
                                <story-title [headingLevel]="4" className="story-font-headline3"> Kontakt</story-title>
                                <div class="flex flex-col">
                                    <div class="flex flex-row gap-2 items-center">
                                        <aui-icon class="story-gray-text" icon="envelope" />
                                        <a class="story-gray-text" href="mailto:automation@antonyco.com">automation@antonyco.com</a>
                                    </div>
                                    <div class="flex flex-row gap-2 items-center">
                                        <aui-icon class="story-gray-text" icon="phone" />
                                        <a class="story-gray-text" href="tel:+420733348555">+420 733 348 555</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="mb-6 mt-4 block h-[1px] w-full bg-surface-background-darken md:hidden md:mb-10 md:mt-8 lg:mb-14 lg:mt-12"
                        ></div>
                        <div class="pr-4 text-center md:text-left">
                            <app-logo class="inline-block aspect-[1602/195] h-[22px]" />
                            <div class="mt-6 block flex justify-center gap-4 md:justify-start md:mt-10">
                                <a
                                    auiItem
                                    [size]="'32'"
                                    href="https://www.linkedin.com/company/108129857/admin/dashboard/"
                                    aria-label="LinkedIn"
                                    target="_blank"
                                    rounded="rounded-full"
                                    rel="noopener noreferrer"
                                    [color]="'info'"
                                >
                                    <aui-icon
                                        auiItemIcon
                                        [icon]="'linkedin'"
                                        [fixedWidth]="true"
                                        [weight]="'fa-brands'"
                                        class="scale-125"
                                    />
                                </a>
                                <!-- <a
                                href="https://www.facebook.com/people/Antonyco/61580415934749/"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <aui-icon
                                    class="block h-8 w-8 rounded-full text-center text-[32px] leading-[32px] text-info"
                                    [icon]="'facebook'"
                                    [weight]="'fa-brands'"
                            /></a> -->
                                <a
                                    auiItem
                                    [size]="'32'"
                                    color="info"
                                    href="https://www.facebook.com/people/Antonyco/61580415934749/"
                                    aria-label="Facebook"
                                    rounded="rounded-full"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <aui-icon
                                        auiItemIcon
                                        class="block h-8 w-8 rounded-full bg-info text-center text-[20px] leading-[32px] text-surface-background"
                                        [icon]="'facebook-f'"
                                        [fixedWidth]="true"
                                        class="scale-125"
                                        [weight]="'fa-brands'"
                                    />
                                </a>
                                <a
                                    auiItem
                                    [size]="'32'"
                                    color="info"
                                    rounded="rounded-full"
                                    href="https://x.com/Antonyco_"
                                    aria-label="Twitter"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <aui-icon
                                        auiItemIcon
                                        class="scale-125 pl-[1px]"
                                        [icon]="'twitter'"
                                        [weight]="'fa-brands'"
                                        [fixedWidth]="true"
                                    />
                                </a>
                                <a
                                    auiItem
                                    [size]="'32'"
                                    color="info"
                                    rounded="rounded-full"
                                    href="https://www.instagram.com/antonycoautomation"
                                    aria-label="Instagram"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <aui-icon
                                        auiItemIcon
                                        class="scale-125"
                                        [icon]="'instagram'"
                                        [fixedWidth]="true"
                                        [weight]="'fa-brands'"
                                    />
                                </a
                                ><a
                                auiItem
                                [size]="'32'"
                                color="info"
                                rounded="rounded-full"
                                href="https://www.youtube.com/@AntonycoAutomation"
                                aria-label="YouTube"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <aui-icon
                                    auiItemIcon
                                    class="scale-125"
                                    [icon]="'youtube'"
                                    [weight]="'fa-brands'"
                                    [fixedWidth]="true"
                                />
                            </a>
                            </div>
                        </div>
                    </div>

                    <div class="aui-font-regular-12 pt-6 text-center md:pt-16">
                        <p class="story-gray-text pb-[10px]">
                            Copyright 2025 © ANTONYCO as a&nbsp;brand of MK SET s.r.o. All right reserved.
                        </p>
                        <p class="inline-block">
                            <a href="https://ralba.co" target="_blank" class="block pt-1 text-primary hover:underline"
                            >Made by
                                <aui-icon
                                    [icon]="'ralba'"
                                    [weight]="'fa-kit'"
                                    class="relative -top-[1px] inline-block"
                                />
                            </a>
                        </p>
                    </div>
                </footer>
            </story-container>
        </story-footer>
    `,
    imports: [
        RouterOutlet,
        StoryNavigationComponent,
        StoryFooterComponent,
        StoryTitleComponent,
        NewsletterComponent,
        LogoComponent,
        StoryContainerComponent,
        RouterLink,
        AuiIconComponent,
        AuiItemComponent,
    ],
})
export class LayoutComponent {
    // hide newsletter on successfully subscribed page
    isSuccessfullySubscribedPage = signal(false);
    router = inject(Router);
    constructor() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.isSuccessfullySubscribedPage.set(event.url.includes(ROUTES_NAMES.successfullySubscribed) ?? false);
            }
        });
    }
}
